import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getAccount } from "@insite/client-framework/Services/AccountService";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, NavigateToReturnUrl } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

replaceInChain(chain, NavigateToReturnUrl, async props => {
    if (props.parameter.skipRedirect) {
        return;
    }

    const state = props.getState();
    const canCheckOut = state.data.carts.byId.current?.canCheckOut;
    const session = getSession(state);
    const homePageUrl = getPageLinkByPageType(state, "HomePage")?.url;
    let languageSpecificLandingPage = session.customLandingPage;
    if (homePageUrl && homePageUrl !== "/") {
        if (languageSpecificLandingPage && languageSpecificLandingPage.startsWith("/")) {
            languageSpecificLandingPage = homePageUrl.concat(session.customLandingPage);
        } else {
            languageSpecificLandingPage = homePageUrl.concat("/", session.customLandingPage);
        }
    }
    const defaultUrl = session.dashboardIsHomepage
        ? getPageLinkByPageType(state, "MyAccountPage")?.url
        : session.customLandingPage;

    const checkoutShippingUrl = getPageLinkByPageType(state, "CheckoutShippingPage")?.url;
    let returnUrl = props.parameter.returnUrl;
    const { userId } = getQueryStrings(state);
    const userSetupPage = getPageLinkByPageType(state, "UserSetupPage");
    const userSetupPageUrl = userSetupPage?.url;
    if (props.apiParameter.session.shipToId === "") {
        returnUrl = `${getPageLinkByPageType(state, "AddressesPage")?.url}?isNewShipTo=true`;
    } else if (returnUrl?.toLowerCase() === checkoutShippingUrl?.toLowerCase()) {
        // const cartResult = await getCart({
        //     cartId: API_URL_CURRENT_FRAGMENT,
        //     expand: ["cartLines", "hiddenproducts"],
        // } as GetCartApiParameter);
        // const { canCheckOut, canBypassCheckoutAddress } = cartResult.cart;
        const checkoutReviewAndSubmitUrl = getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage")?.url;
        const cartUrl = getPageLinkByPageType(state, "CartPage")?.url;
        // if (!canCheckOut || session.isRestrictedProductExistInCart) {
        //     returnUrl = cartUrl;
        // } else if (canBypassCheckoutAddress) {
        //     returnUrl = checkoutReviewAndSubmitUrl;
        // }

        // Removed condition "canBypassCheckoutAddress" to skip CheckoutShippingPage and redirect to CheckoutReviewAndSubmitPage for Single Page Checkout.
        if (!canCheckOut || session.isRestrictedProductExistInCart) {
            returnUrl = cartUrl;
        } else {
            returnUrl = checkoutReviewAndSubmitUrl;
        }
    } else if (
        returnUrl &&
        userSetupPageUrl &&
        returnUrl.toLocaleLowerCase().indexOf(userSetupPageUrl.toLocaleLowerCase()) > -1 &&
        userId
    ) {
        // If customer is not assigned to current user, return to UserAdministration page.
        try {
            await getAccount({ accountId: userId, expand: ["approvers", "roles"] });
        } catch (error) {
            returnUrl = getPageLinkByPageType(state, "UserListPage")?.url;
        }
    }
    window.location.href = defaultUrl || returnUrl || getHomePageUrl(state);
});
